import { Injectable } from '@angular/core';
import { AvailabilityOwnerType, AvailabilityResponse, AvailabilityResponseGroupBy, LegacyAvailabilityMigrationResult, SaveAvailabilityPayload } from '../constants/availability.types';
import { ToTypeOrm } from '../models/_to-type-orm.schema';
import { ApiAuthService } from './api-auth.service';

@Injectable({
  providedIn: 'root',
})
export class AvailabilityService extends ApiAuthService {
  private readonly url = `${this.baseUrl}/time-availability`;

  async getAvailability(
    ownerType: AvailabilityOwnerType,
    ownerId: string | number,
  ): Promise<AvailabilityResponse> {
    return this.request(() =>
      this.http
        .get<AvailabilityResponse>(`${this.url}/${ownerType}/${ownerId}`)
        .toPromise(),
    );
  }

  async saveAvailability(
    payload: SaveAvailabilityPayload,
  ): Promise<AvailabilityResponse> {
    return this.request(() =>
      this.http
        .post<AvailabilityResponse>(`${this.url}`, payload)
        .toPromise(),
    );
  }

  async getAvailabilityForDate(
    ownerType: AvailabilityOwnerType,
    ownerId: string | number,
    date: string,
  ): Promise<any> {
    return this.request(() =>
      this.http
        .get(`${this.url}/${ownerType}/${ownerId}/date/${date}`)
        .toPromise(),
    );
  }

  async deleteOverride(
    ownerType: AvailabilityOwnerType,
    ownerId: string | number,
    date: string,
  ): Promise<AvailabilityResponse> {
    return this.request(() =>
      this.http
        .delete<AvailabilityResponse>(
          `${this.url}/override/${ownerType}/${ownerId}/${date}`,
        )
        .toPromise(),
    );
  }

  async getAvailabilityWithOwnerType(
    ownerType: AvailabilityOwnerType,
    page?: number, limit?: number, order?: {}, filter: any = {}
  ): Promise<AvailabilityResponseGroupBy> {
    return this.getAll(ownerType, page, limit, order, filter);
  }

  async getAll(ownerType: AvailabilityOwnerType, page?: number, limit?: number, order?: {}, filter?: { [key: string]: ToTypeOrm }): Promise<AvailabilityResponseGroupBy> {
    let params = {};
    if (page) params['page'] = page;
    if (limit) params['limit'] = limit;
    if (order) params['order'] = JSON.stringify(order);
    if (filter) params['filter'] = JSON.stringify(filter);
    return this.request(() => this.http.get<AvailabilityResponseGroupBy>(`${this.url}/all/${ownerType}`, { params: params }).toPromise());
  }

  migrateLegacyAvailability(
    ownerType: AvailabilityOwnerType,
    ownerId: string | number,
    dryRun: boolean,
  ): Promise<LegacyAvailabilityMigrationResult> {
    return this.http
      .post<LegacyAvailabilityMigrationResult>(
        `${this.url}/migration/legacy/${ownerType}/${ownerId}`,
        {
          dryRun,
        },
      )
      .toPromise();
  }
}